import { AxiosInstance } from 'axios'
import { axiosProxy } from '@/plugins/axios'
import { PaginationTransformer } from '../pagination/PaginationTransformer'

export interface ProfileReceipt {
  id: number
  /** The invoice number of a manual order, the id otherwise. */
  order_number: string
  order_date: string
  receipt_date: string
  artwork_title: string | null
}

export class ReceiptRepository {
  private api: AxiosInstance = axiosProxy

  // Get the artist's published receipts for a given month.
  async profileReceipts (month: number, year: number, page: number = 1) {
    const res = await this.api.get(`profile/receipts?month=${month}&year=${year}&page=${page}`)
    return {
      data: res.data['data'] as ProfileReceipt[],
      years: res.data['years'] as number[],
      pagination: new PaginationTransformer().toClass(res.data['meta'])
    }
  }

  // Download one receipt as a PDF blob.
  async downloadReceipt (id: number): Promise<Blob> {
    const res = await this.api.get(`profile/receipts/${id}/download?key=${Date.now()}`, {
      responseType: 'blob'
    })
    return res.data
  }
}
